import React, { memo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { ICellRendererParams } from "@ag-grid-community/core";
import { People, Star } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";

import { useEntityUtil } from "fond/hooks/useEntityUtil";
import { ResourceEntity } from "fond/types";

import WriteLockedWarning from "../WriteLockedWarning";

import { CellWrapper, Link } from "./entityCellRenderer.styles";

interface IProps extends ICellRendererParams<ResourceEntity> {
  currentUsername: string;
  isStarred(id?: string): boolean;
}

const EntityTypeCellRenderer: React.FC<IProps> = memo(({ currentUsername, data, isStarred }: IProps) => {
  const starred = isStarred(data?.ID);
  const { getEntityIcon, getEntityUrl, getEntityName } = useEntityUtil();
  const fontWeight = data?.EntityType === "folder" && !data.MultiProject ? 500 : 400;
  const creatorEmail = data?.EntityType === "report" ? data?.Creator.Email : data?.Creator;

  return (
    <CellWrapper data-testid={`${data?.EntityType}-title`}>
      {getEntityIcon(data)}
      <Link component={RouterLink} to={getEntityUrl(data)} sx={{ fontWeight }} data-testid="entity-name">
        {getEntityName(data)}
      </Link>
      {currentUsername !== creatorEmail && (
        <Box display="flex" ml={1} alignItems="center">
          <Tooltip title={`Created by: ${creatorEmail}`}>
            <People color="action" fontSize="small" />
          </Tooltip>
        </Box>
      )}
      {starred && <Star color="action" fontSize="small" sx={{ marginLeft: 1 }} />}
      {data?.EntityType === "project" && data.WriteLocked && <WriteLockedWarning />}
    </CellWrapper>
  );
});

EntityTypeCellRenderer.displayName = "EntityTypeCellRenderer";

export default EntityTypeCellRenderer;
